module.exports = __webpack_public_path__ + "static/media/plan_img.49746b8f.png";